import React from 'react';
import { useNavigate } from 'react-router-dom';

const Urunler = () => {
    const navigate = useNavigate();

    const handlePurchase = () => {
        navigate('/satinal');
    };

    return (
        <div>
            {/* Breadcrumb Section */}
            <div className="breadcrumb-section breadcrumb-bg">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2 text-center">
                            <div className="breadcrumb-text">
                                <p></p>
                                <h1>Ürünler</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="product-section mt-150 mb-150">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                        </div>
                    </div>

                    <div className="row product-lists">
                        <div className="col-lg-4 col-md-6 text-center strawberry">
                            <div className="single-product-item">
                                <div className="product-image">
                                    <a href="single-product.html">
                                        <img src="/assets/img/urunler/logo.png" alt="Oranlar Tablosu" />
                                    </a>
                                </div>
                                <h3>Oranlar Tablosu</h3>
                                <p className="product-price"><span>30 Günlük</span> 1300₺ </p>
                                <button onClick={handlePurchase} className="cart-btn">
                                    <i className="fas fa-shopping-cart"></i> Satın Al
                                </button>
                            </div>
                        </div>


                        <div className="col-lg-4 col-md-6 text-center berry">
                            <div className="single-product-item">
                                <div className="product-image">
                                    <a href="single-product.html">
                                        <img src="assets/img/urunler/logo.png" alt="Oranlar Tablosu" />
                                    </a>
                                </div>
                                <h3>Oranlar Tablosu</h3>
                                <p className="product-price"><span>90 Günlük</span> 3500 ₺ </p>
                                <button onClick={handlePurchase} className="cart-btn">
                                    <i className="fas fa-shopping-cart"></i> Satın Al
                                </button>
                            </div>
                        </div>
                        {/*
                        <div className="col-lg-4 col-md-6 text-center lemon">
                            <div className="single-product-item">
                                <div className="product-image">
                                    <a href="single-product.html">
                                        <img src="assets/img/urunler/logo.png" alt="Oranlar Tablosu" />
                                    </a>
                                </div>
                                <h3>Çok Yakında</h3>
                                <p className="product-price"><span>30 Günlük</span> ₺ </p>
                                <button onClick={handlePurchase} className="cart-btn">
                                    <i className="fas fa-shopping-cart"></i> Satın Al
                                </button>
                            </div>
                        </div>
                        */}

                    </div>

                </div>
            </div>

        </div>
    );
};

export default Urunler;